import firebase from '@/firebase';

const state = {
    // dev only
    olympiadsFetched: false,
    olympiads: [],
    certificate: ""
};


const getters = {
    getOlympiads: state => state.olympiads.sort((a, b) => a.completed - b.completed),
    isOlympiadsFetched: state => state.olympiadsFetched,
    getCertificate: state => state.certificate
}

const mutations = {
    setOlympiads: (state, olympiads) => state.olympiads = [...state.olympiads, ...olympiads],
    switchOlympiadsFetched: state => {
        if (state.olympiadsFetched) {
            state.olympiads = []
        }
        state.olympiadsFetched = !state.olympiadsFetched
    },
    clearOlympiads: state => {
        state.olympiadsFetched = false
        state.olympiads = []
    },
    setCertificate: (state, payload) => state.certificate = payload
}

const actions = {
    fetchOlympiads: async ({ commit, rootState: { auth: { userDetails: { grade, exerciseCompletedIds, premium } } } }) => {
        const olympiads =
            await firebase
                .firestore()
                .collection('olympiads')
                .where('availableFor', 'array-contains', grade)
                .get();
        function transformOlympiad(olympiads) {
            const tempEx = [];
            olympiads.docs.forEach(ex => {
                const questions = [];
                const exData = ex.data();

                // looping ques
                for (let q in exData.questions) {

                    const ops = [];
                    for (let op in exData.questions[q].ops) {
                        ops.push({
                            opId:
                                Number(op), op: exData.questions[q].ops[op]
                        })
                    }

                    questions.push({
                        ...exData.questions[q],
                        ques: q,
                        ops,
                    });
                }


                tempEx.push({
                    ...exData,
                    questions,
                    completed: exerciseCompletedIds.some(ex => ex === exData.olympiadId)
                })
            });
            return tempEx
        }

        const olymps = transformOlympiad(olympiads);

        commit('setOlympiads', olymps)
        commit('switchOlympiadsFetched')
    },
    submitOlympiad: async ({ commit }, payload) => {
        return await firebase.functions().httpsCallable('olympiadSubmit')(payload)
    },
    fetchCertificate: async ({ commit }) => {
        const cert = await firebase.firestore().collection('global').doc('certificate').get();
        commit('setCertificate', cert.data().certificate);
    }
}


export default {
    state,
    getters,
    mutations,
    actions
}